import {CloseCommand} from "slotworks/commands/comms/close-command";
import BetMenuMediator from "slotworks/mediators/bet-menu-mediator";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import SmartButton, {SmartButtonFlag} from "slotworks/smart-button/smart-button";
import SuperState from "slotworks/state-machine/states/superstate";
import Components from "../../../components/components";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import AutoplayModel from "slotworks/model/autoplay-model";
import {showPFSSummary} from "../../../commands/promo-free-spins/show-pfs-summary";
import Regulation from "slotworks/integration/revolver/regulations/regulation";

export default class WinCycle extends SuperState {

    private betMenuMediator: BetMenuMediator;

    private readyToExit: boolean;
    private pendingExit: boolean;

    public onEnter() {
        if(CampaignsModel.isFreespinsActive() && !AutoplayModel.isAutoPlaying()){
            Components.promoBetBar.setEnabled(true);
        }

        this.readyToExit = false;
        this.pendingExit = false;

        let winnings = GameState.getCurrentGame().getCurrentRecord().creditsWon;

        this.betMenuMediator = new BetMenuMediator();

        const record = GameState.getCurrentGame().getCurrentRecord();
        let closeGame = true;

        if (record instanceof SpinRecord) {
            if (record.freespinsTriggered || record.isBonusTriggered()) {
                closeGame = false;
            }
        }

        if (record instanceof FreespinRecord) {
            winnings = GameState.getCurrentGame().getRunningFreespinsWinTotal();

            closeGame = false;
        }

        if (record.beenPaid) {
            closeGame = true;
        }

        if (closeGame) {
            record.beenPaid = true;

            winnings = GameState.getCurrentGame().totalCreditsWon;

            SmartButton.setFlag(SmartButtonFlag.AWAITING_RESPONSE, true);

            CloseCommand().then(() => {
                this.readyToExit = true;

                if (this.pendingExit) {
                    this.complete();
                } else {
                    this.betMenuMediator.start().execute();

                    SmartButton.setFlag(SmartButtonFlag.AWAITING_RESPONSE, false);
                    SmartButton.setFlag(SmartButtonFlag.IDLE, true);

                    showPFSSummary();
                }
            });
        } else {
            this.readyToExit = true;
            if (this.pendingExit) {
                this.complete();
            }
        }

        Components.betBar.winnings.setWinnings(record.creditsWon, winnings);
        Regulation.updateNetPosition(GameState.getNetPosition());
    }

    public onSkip() {
        this.betMenuMediator.end();
        SmartButton.setFlag(SmartButtonFlag.IDLE, false);
        this.skip();
    }

    public onExit() {
        this.pendingExit = true;
        if (this.readyToExit) {
            this.betMenuMediator.end();
            this.complete();
        }
    }

}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/super-states/win-cycle.ts